import { axiosInstance } from ".."

const approveCustomOrder = async (data) =>{

    return new Promise(async (resolve,reject)=>{
        axiosInstance.post(`/internal/CustomOrder/orderApprove`,data).then((res) => { 
            if(res.status === 200){
                return resolve(res)
            }
            return resolve(res)
        }).catch((err) => {
            return reject(err)
        })
    })
}

export default approveCustomOrder;